const lifeDriver = {
  path: '/life-driver',
  name: 'lifeDriver',
  component: () => import("@views/life-driver/life-driver.vue"),
  children: [
    {
      path: 'index',
      component: () => import("@views/life-driver/index.vue"),
      meta: {
//        tabBar: false,
//        keepAlive: true·
      },
    },{
      path: 'search-driver',
      component: () => import("@views/life-driver/search-driver.vue"),
      meta: {
        tabBar: false
      },
    },{
      path: 'activity-sign',
      component: () => import("@views/life-driver/activity-sign.vue"),
      meta: {
        tabBar: false
      },
    },{
      path: 'driver-detail',
      component: () => import("@views/life-driver/driver-detail.vue"),
      meta: {
       // tabBar: false
      },
    },{
      path: 'set-driver',
      component: () => import("@views/life-driver/set-driver.vue"),
      meta: {
        tabBar: false
      }
    }, {
      path: 'life-photo',
      component: () => import("@views/life-driver/life-photo.vue"),
      meta: {
        tabBar: false
      }
    },{
      path: 'participants',
      component: () => import("@views/life-driver/participants.vue"),
      meta: {
        tabBar: false
      }
    },{
      path: 'create-active',
      component: () => import("@views/life-driver/create-active.vue"),
      meta: {
        tabBar: false,
        keepAlive:true
      }
    },{
      path: 'create-success',
      component: () => import("@views/life-driver/create-success.vue"),
      meta: {
        tabBar: false
      }
    },{
      path: 'sign-page',
      component: () => import("@views/life-driver/sign-page.vue"),
      meta: {
        tabBar: false
      }
  }
    ]
}

export default lifeDriver
